import { type FC, useId } from 'react';

import * as styles from './brand.css';
import { STREAMLAIN_CORE_LOGO } from './streamlain-logo-mark';

export interface StreamLainWordmarkProps {
  className?: string;
  idsPrefix?: string;
}

const normalizeSvgId = (id: string) => id.replace(/[^a-zA-Z0-9_-]/g, '');

export const StreamLainWordmark: FC<StreamLainWordmarkProps> = ({
  className,
  idsPrefix,
}) => {
  const generatedId = useId();
  const prefix =
    idsPrefix ?? `streamlain-wordmark-${normalizeSvgId(generatedId)}`;
  const streamGradientId = `${prefix}-stream`;
  const lainGradientId = `${prefix}-lain`;

  return (
    <g className={`${styles.wordmark} ${className ?? ''}`.trim()}>
      <defs>
        <linearGradient id={streamGradientId} x1="0" y1="0" x2="0" y2="1">
          <stop
            offset="0"
            stopColor={`var(--sl-brand-wordmark-stream-start, ${STREAMLAIN_CORE_LOGO.wordmark.streamGradient[0]})`}
          />
          <stop
            offset="1"
            stopColor={`var(--sl-brand-wordmark-stream-end, ${STREAMLAIN_CORE_LOGO.wordmark.streamGradient[1]})`}
          />
        </linearGradient>
        <linearGradient id={lainGradientId} x1="0" y1="0" x2="0" y2="1">
          <stop
            offset="0"
            stopColor={`var(--sl-brand-wordmark-lain-start, ${STREAMLAIN_CORE_LOGO.wordmark.lainGradient[0]})`}
          />
          <stop
            offset="1"
            stopColor={`var(--sl-brand-wordmark-lain-end, ${STREAMLAIN_CORE_LOGO.wordmark.lainGradient[1]})`}
          />
        </linearGradient>
      </defs>
      <g transform={STREAMLAIN_CORE_LOGO.wordmark.transform}>
        <path
          d={STREAMLAIN_CORE_LOGO.wordmark.streamPath}
          fill={`url(#${streamGradientId})`}
        />
        <path
          d={STREAMLAIN_CORE_LOGO.wordmark.lainPath}
          fill={`url(#${lainGradientId})`}
        />
      </g>
    </g>
  );
};
